import React from "react";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../components/DynamicForm";
import FormSkeletonLoader from "../../../components/FormSkeletonLoader";
import {
  myProfileFields,
  myProfileValidationSchema,
} from "../../../Schema/MyProfileSchema";
import {
  useGetMyProfile,
  useUpdateMyProfile,
} from "../../../custom-hooks/queries";
import NotificationModal from "../../../components/NotificationModal";

const MyProfile = () => {
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const { data: profileDetails, isLoading } = useGetMyProfile();
  const { mutate: updateProfile, isError } = useUpdateMyProfile();

  const defaultValues = {
    email: profileDetails?.email || "",
    first_name: profileDetails?.first_name || "",
    last_name: profileDetails?.last_name || "",
    phone_number: profileDetails?.phone_number || "",
    office_phone_number: profileDetails?.office_phone_number || "",
    contact_preference: profileDetails?.contact_preference || "Office_Phone",
    profile_pic_url: profileDetails?.profile_pic_url || "",
  };

  const onSubmit = (data) => {
    updateProfile(data, {
      onSuccess: () => {
        setMessage("Profile updated successfully");
        setShow(true);
        setTimeout(() => setShow(false), 2000);
      },
      onError: (error) => {
        setMessage(error.response?.data?.message || "Failed to update profile");
        setShow(true);
      },
    });
  };

  if (isLoading) {
    return <FormSkeletonLoader />;
  }
  const modifiedFields = myProfileFields.map((field) =>
    field.name === "email"
      ? {
          ...field,
          disabled: true,
          readOnly: true,
          className: "bg-gray-50 text-gray-500 cursor-not-allowed",
        }
      : field
  );

  return (
    <div className="w-full">
      <DynamicForm
        formTitle="My Profile"
        formDescription="Update your profile information below."
        fields={modifiedFields}
        validationSchema={myProfileValidationSchema}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        isUpdate={true}
        className="w-full"
      />
      <NotificationModal
        open={show}
        setOpen={setShow}
        desc={message}
        title={isError ? "Error" : "Success"}
        error={isError}
      />
    </div>
  );
};

export default MyProfile;
